<div class="header">
  <div class="link-back">
      <a class="cosentino-link primaryDefault-color typography-body-m-regular" gtm-label="mis_displays_ver_modal_galeria" gtm-usertype="ad" target="_self" (click)="this.goToList()">
          <div class="maxContent">
              <div class="link-container">
                  <svg width="24" height="24"  viewBox="0 0 24 24" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                      <path class="primaryDefault" d="M14.0002 17.3L8.7002 12L14.0002 6.69995L14.7002 7.39995L10.1002 12L14.7002 16.6L14.0002 17.3Z" fill="#232323"></path>
                  </svg>
                  <span>
                      {{ 'my_displays.come_back_to_my_displays' | translate }}
                  </span>
              </div>
          </div>
      </a>
  </div>
  <div class="title status">
    <section class="flexible-column">
          <div class="titleTextName">
              <span class="title-container typography-title-l" data-id="changeNameName">

                  <span >
                      {{ 'my_displays.register_new_display_label' | translate }}
                  </span>
              </span>
          </div>
      </section>
  </div>
</div>

<div *ngIf="!loadingCollaborators && !loadingDisplayInfo" class="bg-[#f5f7fc] p-6 min-h-screen">
  <div *ngIf="step > 0" class="px-6 py-4 mb-4">
    <app-progress-bar
      [steps]="progressSteps"
      [currentStep]="step"
      orientation="horizontal"
      [showDescription]="true">
    </app-progress-bar>
  </div>

  <!-- Step 0: Type of display -->
  <div *ngIf="step === 0">
    <div class="bg-white px-6 py-8">
      <span class="typography-title-m">
        {{ 'my_displays.choose_type' | translate }}
      </span>
      <div class="mb-6 header"></div>
      <alert [type]="'warning'" class="inputs grid grid-cols-1 gap-4 mb-6 items-center">
        {{ 'my_displays.alert_attach_sketch' | translate }}
      </alert>
      <div class="inputs grid grid-cols-1 md:grid-cols-2 pb-4 gap-4">
        {{ 'my_displays.choose_type_desc' | translate }}
      </div>
      <div class="inputs grid grid-cols-1 md:grid-cols-1 gap-4 mb-6">
        <app-radio
          label="{{ 'my_displays.not_replacement' | translate }}"
          [checked]="isReplacement === false"
          (onClick)="setIsReplacement(false)"></app-radio>
        <app-radio
          label="{{ 'my_displays.replacement' | translate }}"
          [checked]="isReplacement === true"
          (onClick)="setIsReplacement(true)"></app-radio>
      </div>
      <div *ngIf="isReplacement === true && ($any(userInfo.accountType) === 'RETAIL' || $any(userInfo.accountType) === 'DESIGNER')" class="inputs grid grid-cols-2 md:grid-cols-2 gap-4 mb-6 gap-2">
        <div>
          <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.which_brand' | translate }}</p>
          <app-select
            [disabled]="false"
            [placeholder]="'my_displays.which_brand' | translate"
            [options]="whichBrandOptions"
            [selectedValue]="selectedWhichBrand"
            (selectedValueChanged)="selectWhichBrand($event)">
          </app-select>
        </div>
        <div>
          <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.which_display' | translate }}</p>
          <app-select
            [disabled]="false"
            [placeholder]="'my_displays.which_display' | translate"
            [options]="whichDisplayOptions"
            [selectedValue]="selectedWhichDisplay"
            (selectedValueChanged)="selectWhichDisplay($event)">
          </app-select>
        </div>
      </div>
      <div class="inputs grid grid-cols-1 md:grid-cols-2 mt-4 gap-4">
        {{ 'my_displays.mandatory_fields' | translate }}
      </div>
    </div>
  </div>
  <!-- Step 1: addForm -->
  <div *ngIf="step === 1">
    <div class="bg-white px-6 py-8 mt-6">
      <span class="typography-title-m">
        {{ editingIndex !== null ? ('my_displays.edit_application_title' | translate) : ('my_displays.add_application_title' | translate) }}
      </span>
      <div class="mb-6 header"></div>
      <alert *ngIf="$any(userInfo.accountType) === 'RETAIL' || $any(userInfo.accountType) === 'DESIGNER'" [type]="'info'" class="inputs grid grid-cols-1 gap-4 mb-6 items-center">
        {{ 'my_displays.alert_plan_installation' | translate }}
      </alert>
      <!-- K&B Form -->
      <div *ngIf="$any(userInfo.accountType) === 'RETAIL' || $any(userInfo.accountType) === 'DESIGNER'">
        <div class="inputs grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 gap-2">
          <div>
            <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.application_label' | translate }}</p>
            <app-select
              [disabled]="false"
              [searchable]="false"
              [placeholder]="'my_displays.application_placeholder' | translate"
              [options]="applicationOptions"
              [selectedValue]="selectedApplicationOption"
              (selectedValueChanged)="selectApplication($event)">
            </app-select>
          </div>
          <div>
            <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.select_professional_label' | translate }}</p>
            <app-select
              [disabled]="false"
              [placeholder]="'my_displays.select_professional_placeholder' | translate"
              [options]="professionalOptions"
              [selectedValue]="selectedProfessionalOption"
              (selectedValueChanged)="selectProfessional($event)">
            </app-select>
          </div>
        </div>
        <div class="inputs flex flex-col gap-1">
          <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.indicate_installation_date_label' | translate }}</p>
          <app-date-filter
            class=""
            [config]="{ label: 'my_displays.indicate_installation_date_label' | translate, placeholder: 'my_displays.indicate_installation_date_label' | translate, max: null, format: getFormatDate() }"
            [isLoading]="false"
            labelClass=" m-0 mb-2 typography-body-m-medium"
            [initialValue]="installationDateJs"
            (dateChanged)="onDateChanged($event)"
            (cleared)="onDateCleared()"
          ></app-date-filter>
          <div *ngIf="installationDateError" class="text-xs mt-6" style="color:#dc2626;">
            {{ 'my_displays.invalid_date_error' | translate }}
          </div>
        </div>
      </div>
      <!-- Fabricator Form -->
      <div *ngIf="$any(userInfo.accountType) === 'FABRICATOR' || $any(userInfo.accountType) === 'DISTRIBUTOR'">
        <div class="inputs grid grid-cols-1 md:grid-cols-1 gap-4 mb-6">
          <span class="text-lg font-semibold text-gray-600 mb-4">{{ 'my_displays.display_destination_question' | translate }}</span>
          <app-radio
            label="{{ 'my_displays.for_me' | translate }}"
            [checked]="isForMe === true"
            (onClick)="setIsForMe(true)"></app-radio>
          <app-radio
            label="{{ 'my_displays.for_related_kb' | translate }}"
            [checked]="isForMe === false"
            (onClick)="setIsForMe(false)"></app-radio>
        </div>
        <div *ngIf="isForMe === false" class="inputs grid grid-cols-1 md:grid-cols-1 gap-4 mb-6">
          <alert [type]="'info'">
            {{ 'my_displays.select_associated_store_info' | translate }}
          </alert>
            <div class="w-1/2">
              <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.select_professional_label' | translate }}</p>
              <app-select
                [disabled]="false"
                [placeholder]="'my_displays.select_professional_placeholder' | translate"
                [options]="professionalOptions"
                [selectedValue]="selectedProfessionalOption"
                (selectedValueChanged)="selectProfessional($event)">
              </app-select>
            </div>
        </div>
        <div class="inputs grid grid-cols-1 md:grid-cols-1 gap-4 mb-6">
          <span class="text-lg font-semibold text-gray-600 mb-4">{{ 'my_displays.display_to_install_info' | translate }}</span>
          <div class="w-1/2">
            <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.application_label' | translate }}</p>
            <app-select
              [disabled]="false"
              [searchable]="false"
              [placeholder]="'my_displays.application_placeholder' | translate"
              [options]="applicationOptions"
              [selectedValue]="selectedApplicationOption"
              (selectedValueChanged)="selectApplication($event)">
            </app-select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Step 2: Add/Edit Applications -->
  <div *ngIf="step === 2">
    <div *ngIf="!applicationTypeSelected && addingNew === true" class="bg-white px-6 py-8 mt-6">
      <span class="text-lg font-semibold text-gray-400 mb-4">
        {{ editingIndex !== null ? ('my_displays.edit_application_title' | translate) : ('my_displays.add_application_title' | translate) }}
      </span>
      <div class="mb-6 header"></div>
      <div *ngIf="this.addForm.application === 'kitchen'" class="gridContainer grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div class="flex flex-col" (click)="onApplicationChange('kitchen')" [ngClass]="{'application-item': applicationForm.application === 'kitchen'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/kitchen.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_kitchen_countertop' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('furniture')" [ngClass]="{'application-item': applicationForm.application === 'furniture'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/furniture.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_furniture' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('backsplash')" [ngClass]="{'application-item': applicationForm.application === 'backsplash'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/backsplash.png\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_backsplash' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('cover')" [ngClass]="{'application-item': applicationForm.application === 'cover'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/cover2.png\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_cover' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('sink')" [ngClass]="{'application-item': applicationForm.application === 'sink'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/sink.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_sink' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('panel')" [ngClass]="{'application-item': applicationForm.application === 'panel'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/panel.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_panel' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('flooring')" [ngClass]="{'application-item': applicationForm.application === 'flooring'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/flooring.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_flooring' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('other')" [ngClass]="{'application-item': applicationForm.application === 'other'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/other.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_other' | translate }}
          </div>
        </div>
      </div>
      <div *ngIf="this.addForm.application === 'bath'" class="gridContainer grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div class="flex flex-col" (click)="onApplicationChange('bath')" [ngClass]="{'application-item': applicationForm.application === 'bath'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/bath.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_bath_countertop' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('bath_showertray')" [ngClass]="{'application-item': applicationForm.application === 'bath_showertray'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/bath_showertray.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_bath_showertray' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('bath_cladding')" [ngClass]="{'application-item': applicationForm.application === 'bath_cladding'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/bath_cladding.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_bath_cladding' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('bath_panels')" [ngClass]="{'application-item': applicationForm.application === 'bath_panels'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/bath_panels.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_bath_panels' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('bath_flooring')" [ngClass]="{'application-item': applicationForm.application === 'bath_flooring'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/bath_flooring.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_bath_flooring' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('bath_sink')" [ngClass]="{'application-item': applicationForm.application === 'bath_sink'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/bath_sink.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_bath_sink' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('bath_others')" [ngClass]="{'application-item': applicationForm.application === 'bath_others'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/bath_others.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_bath_others' | translate }}
          </div>
        </div>
      </div>
      <div *ngIf="this.addForm.application === 'other_spaces'" class="gridContainer grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div class="flex flex-col" (click)="onApplicationChange('other_furniture_top')" [ngClass]="{'application-item': applicationForm.application === 'other_furniture_top'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/other_furniture_top.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_other_furniture_top' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('other_cladding')" [ngClass]="{'application-item': applicationForm.application === 'other_cladding'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/other_cladding.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_other_cladding' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('other_panel')" [ngClass]="{'application-item': applicationForm.application === 'other_panel'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/other_panel.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_other_panel' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('other_flooring')" [ngClass]="{'application-item': applicationForm.application === 'other_flooring'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/other_flooring.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_other_flooring' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('other_office')" [ngClass]="{'application-item': applicationForm.application === 'other_office'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/other_office.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_other_office' | translate }}
          </div>
        </div>
        <div class="flex flex-col" (click)="onApplicationChange('other_others')" [ngClass]="{'application-item': applicationForm.application === 'other_others'}">
          <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/other_others.jpg\')'}"></div>
          <div class="subtitleContainer typography-body-m-regular text-justify">
            {{ 'my_displays.application_other_others' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="applicationTypeSelected">
      <div class="bg-white px-6 py-4 mt-6">
        <span class="text-lg font-semibold text-gray-400 mb-4">
          {{ ('my_displays.select_application_type' | translate) }}
        </span>
        <div class="mb-6 header"></div>
        <div class="flex items-center bg-white px-6 py-4 mt-6">
          <div class="imageMini" [ngStyle]="{'background-image': 'url(\'assets/images/my-displays/' + applicationForm.application + '.jpg\')'}"></div>
          <div class="application-name">{{ 'my_displays.application_' + applicationForm.application | translate }}</div>
          <a class="modify-application" (click)="changeApplication()">{{ 'my_displays.modify_application' | translate }}</a>
        </div>
      </div>

      <div *ngIf="!applicationColorSelected && (this.applicationForm.application !== 'sink' && this.applicationForm.application !== 'bath_showertray' && this.applicationForm.application !== 'bath_sink')" class="bg-white px-6 py-4 mt-6">
        <span class="text-lg font-semibold text-gray-400 mb-4">
          {{ ('my_displays.select_application_color' | translate) }}
        </span>
        <div class="application-name">{{ 'my_displays.select_application_color_desc' | translate }}</div>
        <div class="mb-6 header"></div>
        <div class="flex items-center bg-white px-6 py-4 mt-6">
            <div class="flex-1 flex flex-col gap-3 px-4">
                <div class="max-w-none md:max-w-[280px]">
                    <app-search-input
                        [placeholder]="'my_displays.type_to_search' | translate"
                        [(ngModel)]="colorSearchValue"
                        (ngModelChange)="searchColors()"
                    ></app-search-input>
                </div>
                <p class="m-0 typography-body-m-medium">
                    {{'my_displays.filter_by' | translate}}
                </p>
                <div class="flex-col md:flex-row flex gap-4">
                    <div class="flex-1 max-w-none md:max-w-[250px]">
                        <p class="m-0 mb-2 typography-body-m-medium">
                            {{'brand' | translate}}:
                        </p>
                        <app-select
                            [placeholder]="'my_displays.display_color_filter_by_brand' | translate"
                            [options]="brandOptions"
                            [selectedValue]="selectedBrand"
                            (selectedValueChanged)="selectedBrand = $event; searchColors()"
                        ></app-select>
                    </div>

                    <div class="flex-1 max-w-none md:max-w-[250px]">
                        <p class="m-0 mb-2 typography-body-m-medium">
                            {{'tone' | translate}}:
                        </p>
                        <app-select
                            [placeholder]="'my_displays.display_color_filter_by_tone' | translate"
                            [options]="toneOptions"
                            [selectedValue]="selectedTone"
                            (selectedValueChanged)="selectedTone = $event; searchColors()"
                        ></app-select>
                    </div>

                    <div class="flex items-center flex-1 justify-center md:justify-end">
                        <div class="mt-0 md:mt-5">
                            <app-link class="text-primary-default" size="large" (onClick)="clearFilters()">
                                {{'my_displays.display_color_clear_filters' | translate}}
                            </app-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex items-center bg-white px-6 py-4">
          <app-loading [isLoading]="loadingColors"></app-loading>
          <div *ngIf="!loadingColors && filteredColors.length > 0" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <app-color *ngFor="let color of filteredColors; let i = index"
              [mainImage]="color.pictures!.thumb!"
              [name]="color.color!"
              [brand]="color.brand!"
              [colorCode]="color.colorCode!"
              [isSelected]="applicationForm.color === color.colorCode"
              [discount]="color.discount || ''"
              [isNew]="isColorNew(color.releaseDate!) || false"
              (colorSelected)="selectColor($event)"
            ></app-color>
          </div>
          <!-- Mensaje si no hay colores -->
          <div *ngIf="!loadingColors && filteredColors.length === 0" class="empty-container flex justify-center">
            <div class="empty-title typography-title-l">{{ 'my_sales.no_hay_resultados_newclients' | translate }}</div>
          </div>
        </div>
      </div>
      <div *ngIf="!applicationColorSelected && this.applicationForm.application === 'sink'" class="bg-white px-6 py-4 mt-6">
        <span class="text-lg font-semibold text-gray-400 mb-4">
          {{ ('my_displays.fill_application_details' | translate) }}
        </span>
        <div class="mb-6 header"></div>
        <div class="flex items-center bg-white px-6 py-4 mt-6">
         <!--  Aquí los filtros y el buscador -->
        </div>
          <div class="grid grid-cols-[repeat(3,1fr)] gap-5">
              <div class="col-span-3 md:col-span-1">
                  <p class="m-0 mb-2 typography-body-m-medium">
                      {{'my_displays.model_label' | translate}}:
                  </p>
                  <app-select
                      [disabled]="false"
                      [placeholder]="'my_displays.model_placeholder' | translate"
                      [options]="sinkOptions"
                      [selectedValue]="selectedSink"
                      (selectedValueChanged)="selectSinkModel($event)"
                  ></app-select>
              </div>
              <div class="col-span-3 md:col-span-1">
                  <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_sales.brand_label' | translate }}</p>
                  <app-select
                      [disabled]="!sinkForm.model"
                      [placeholder]="'my_displays.brand_placeholder' | translate"
                      [options]="sinkBrandOptions"
                      [selectedValue]="selectedSinkBrandOption"
                      (selectedValueChanged)="selectSinkBrands($event)">
                  </app-select>
              </div>
              <div class="col-span-3 md:col-span-1">
                  <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.color_label' | translate }}</p>
                  <app-select
                      [disabled]="!sinkForm.brand"
                      [placeholder]="'my_displays.color_placeholder' | translate"
                      [options]="sinkColorOptions"
                      [selectedValue]="selectedSinkColorOption"
                      (selectedValueChanged)="selectSinkColor($event)">
                  </app-select>
              </div>
              <div class="col-span-3 md:col-span-1">
                  <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.finish_label' | translate }}</p>
                  <app-select
                      [disabled]="!sinkForm.color"
                      [placeholder]="'my_displays.finish_placeholder' | translate"
                      [options]="sinkFinishOptions"
                      [selectedValue]="selectedSinkFinishOption"
                      (selectedValueChanged)="selectSinkFinish($event)">
                  </app-select>
              </div>
              <div class="col-span-3 md:col-span-1">
                  <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.format_label' | translate }}</p>
                  <app-select
                      [disabled]="!sinkForm.finish"
                      [placeholder]="'my_displays.format_placeholder' | translate"
                      [options]="sinkFormatOptions"
                      [selectedValue]="selectedSinkFormatOption"
                      (selectedValueChanged)="selectSinkFormat($event)">
                  </app-select>
              </div>
          </div>
        <div class="flex flex-col md:flex-row items-center gap-5 bg-white px-6 py-4">
        </div>
        <div class="flex flex-col md:flex-row items-center gap-5 bg-white px-6 py-4">
        </div>
      </div>

      <div *ngIf=" this.applicationForm.application === 'bath_showertray'" class="bg-white px-6 py-4 mt-6">
        <span class="text-lg font-semibold text-gray-400 mb-4">
          {{ ('my_displays.select_model' | translate) }}
        </span>
        <div class="mb-6 header"></div>

        <!-- Lista de productos con imagen y nombre -->
        <div *ngIf="this.showerForm.model === ''" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
          <div *ngFor="let model of showerModels; let i = index" (click)="onShowerModelChange(model)">
              <span class="text-lg font-semibold text-gray-600 mb-4 text-center">
                {{ model }}
                <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/models/showertray_' + model + '.png\')'}"></div>
              </span>
          </div>
        </div>
        <div *ngIf="this.showerForm.model !== ''" class="flex items-center bg-white px-6 py-4 mt-6">
          <div class="imageMini" [ngStyle]="{'background-image': 'url(\'assets/images/models/showertray_' + this.showerForm.model + '.png\')'}"></div>
          <div class="application-name">{{ ('my_displays.model_label' | translate) + ' ' + this.showerForm.model }}</div>
          <a class="modify-application" (click)="changeModel()">{{ 'my_displays.modify_model' | translate }}</a>
        </div>
      </div>
      <div *ngIf="applicationModelSelected && this.applicationForm.application === 'bath_showertray'" class="bg-white px-6 py-4 mt-6">
        <span class="text-lg font-semibold text-gray-400 mb-4">
          {{ ('my_displays.fill_application_details' | translate) }}
        </span>
        <div class="mb-6 header"></div>
        <div class="grid grid-cols-[repeat(3,1fr)] gap-5">
            <div class="col-span-3 md:col-span-1">
                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.brand_label' | translate }}</p>
                <app-select
                    [disabled]="false"
                    [placeholder]="'my_displays.brand_placeholder' | translate"
                    [options]="sinkBrandOptions"
                    [selectedValue]="selectedSinkBrandOption"
                    (selectedValueChanged)="selectedFullConfigBrands($event)">
                </app-select>
            </div>
            <div class="col-span-3 md:col-span-1">
                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.color_label' | translate }}</p>
                <app-select
                    [disabled]="!sinkForm.brand"
                    [placeholder]="'my_displays.color_placeholder' | translate"
                    [options]="sinkColorOptions"
                    [selectedValue]="selectedSinkColorOption"
                    (selectedValueChanged)="selectedFullConfigColor($event)">
                </app-select>
            </div>
            <div class="col-span-3 md:col-span-1">
                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.finish_label' | translate }}</p>
                <app-select
                    [disabled]="!sinkForm.color"
                    [placeholder]="'my_displays.finish_placeholder' | translate"
                    [options]="sinkFinishOptions"
                    [selectedValue]="selectedSinkFinishOption"
                    (selectedValueChanged)="selectedFullConfigFinish($event)">
                </app-select>
            </div>
            <div class="col-span-3 md:col-span-1">
                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.worktop_length_label' | translate }}</p>
                <app-input
                    class="w-1/2"
                    type="number"
                    min="0"
                    [disabled]="!sinkForm.finish"
                    (change)="onWorktopLengthChange($event)">
                </app-input>
            </div>
            <div class="col-span-3 md:col-span-1">
                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.worktop_width_label' | translate }}</p>
                <app-input
                    class="w-1/2"
                    type="number"
                    min="0"
                    [disabled]="!sinkForm.finish"
                    (change)="onWorktopWidthChange($event)">
                </app-input>
            </div>
        </div>
        <div *ngIf="$any(userInfo.accountType) === 'FABRICATOR' || $any(userInfo.accountType) === 'DISTRIBUTOR'">
          <div class="flex items-center bg-white px-6 py-4 mt-6">
            <span class="font-semibold text-gray-400 mb-4">{{ 'my_displays.stock_available' | translate }}</span>
          </div>
          <div class="flex items-center bg-white px-6 py-4">
            <app-radio
                class="mr-6"
                label="{{ 'my_displays.stock_yes' | translate }}"
                [checked]="availableStock === true"
                (onClick)="setAvailableStock(true)"></app-radio>
              <app-radio
                label="{{ 'my_displays.stock_no' | translate }}"
                [checked]="availableStock === false"
                (onClick)="setAvailableStock(false)"></app-radio>
          </div>
          <div *ngIf="!availableStock" class="flex items-center bg-white px-6 py-4 mt-6">
            <span class="font-semibold text-gray-400 mb-4">{{ 'my_displays.prefered_arrival_date' | translate }}</span>
          </div>
          <div *ngIf="!availableStock" class="flex flex-col bg-white px-6 py-4">
            <app-date-filter
              [hasError]="preferedArrivalDateError"
              [initialValue]="applicationForm.preferedArrivalDateDate"
              [config]="{ label: 'my_displays.prefered_arrival_date_label' | translate, placeholder: 'my_displays.prefered_arrival_date_placeholder' | translate, max: null}"
              [isLoading]="false"
              (dateChanged)="onPreferedArrivalDateChanged($event)"
              (cleared)="onDateCleared()"
            ></app-date-filter>
             <div *ngIf="preferedArrivalDateError" style="color:#dc2626; font-size:12px; margin-top:6px;">
              {{ 'my_displays.invalid_date_error' | translate }}
            </div>
          </div>
        </div>
        <div class="flex flex-col md:flex-row items-center gap-5 bg-white px-6 py-4">
        </div>
        <div class="flex flex-col md:flex-row items-center gap-5 bg-white px-6 py-4">
        </div>
      </div>
      <div *ngIf="this.applicationForm.application === 'bath_sink'" class="bg-white px-6 py-4 mt-6">
        <span class="text-lg font-semibold text-gray-400 mb-4">
          {{ ('my_displays.select_model' | translate) }}
        </span>
        <div class="mb-6 header"></div>
        <div *ngIf="this.sinkForm.model === ''" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
          <div *ngFor="let model of sinkModels; let i = index" (click)="onSinkModelChange(model)">
            <span class="text-lg font-semibold text-gray-600 mb-4">
              {{ model }}
              <div class="imageContainer" [ngStyle]="{'background-image': 'url(\'assets/images/models/sink_' + model + '.png\')'}"></div>
            </span>
          </div>
        </div>
        <div *ngIf="this.sinkForm.model !== ''" class="flex items-center bg-white px-6 py-4 mt-6">
          <div class="imageMini" [ngStyle]="{'background-image': 'url(\'assets/images/models/sink_' + this.sinkForm.model + '.png\')'}"></div>
          <div class="application-name">{{ ('my_displays.model_label' | translate) + ' ' + this.sinkForm.model }}</div>
          <a class="modify-application" (click)="changeModel()">{{ 'my_displays.modify_model' | translate }}</a>
        </div>
      </div>
      <div *ngIf="applicationModelSelected && this.applicationForm.application === 'bath_sink'" class="bg-white px-6 py-4 mt-6">
        <span class="text-lg font-semibold text-gray-400 mb-4">
          {{ ('my_displays.fill_application_details' | translate) }}
        </span>
        <div class="mb-6 header"></div>
        <div class="grid grid-cols-[repeat(3,1fr)] gap-5">
          <div class="col-span-3 md:col-span-1">
            <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.brand_label' | translate }}</p>
            <app-select
              [disabled]="false"
              [placeholder]="'my_displays.brand_placeholder' | translate"
              [options]="sinkBrandOptions"
              [selectedValue]="selectedSinkBrandOption"
              (selectedValueChanged)="selectedFullConfigBrands($event)">
            </app-select>
          </div>
          <div class="col-span-3 md:col-span-1">
            <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.color_label' | translate }}</p>
            <app-select
              [disabled]="!sinkForm.brand"
              [placeholder]="'my_displays.color_placeholder' | translate"
              [options]="sinkColorOptions"
              [selectedValue]="selectedSinkColorOption"
              (selectedValueChanged)="selectedFullConfigColor($event)">
            </app-select>
          </div>
          <div class="col-span-3 md:col-span-1">
            <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.finish_label' | translate }}</p>
            <app-select
              [disabled]="!sinkForm.color"
              [placeholder]="'my_displays.finish_placeholder' | translate"
              [options]="sinkFinishOptions"
              [selectedValue]="selectedSinkFinishOption"
              (selectedValueChanged)="selectedFullConfigFinish($event)">
            </app-select>
          </div>
          <div class="col-span-3 md:col-span-1">
            <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.worktop_length_label' | translate }}</p>
            <app-input
              class="w-1/2"
              type="number"
              min="0"
              [disabled]="!sinkForm.finish"
              (change)="onWorktopLengthChange($event)">
            </app-input>
          </div>
          <div class="col-span-3 md:col-span-1">
            <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.worktop_width_label' | translate }}</p>
            <app-input
              class="w-1/2"
              type="number"
              min="0"
              [disabled]="!sinkForm.finish"
              (change)="onWorktopWidthChange($event)">
            </app-input>
          </div>
        </div>
        <div *ngIf="$any(userInfo.accountType) === 'FABRICATOR' || $any(userInfo.accountType) === 'DISTRIBUTOR'">
          <div class="flex items-center bg-white px-6 py-4 mt-6">
            <span class="font-semibold text-gray-400 mb-4">{{ 'my_displays.stock_available' | translate }}</span>
          </div>
          <div class="flex items-center bg-white px-6 py-4">
            <app-radio
              class="mr-6"
              label="{{ 'my_displays.stock_yes' | translate }}"
              [checked]="availableStock === true"
              (onClick)="setAvailableStock(true)"></app-radio>
            <app-radio
              label="{{ 'my_displays.stock_no' | translate }}"
              [checked]="availableStock === false"
              (onClick)="setAvailableStock(false)"></app-radio>
          </div>
          <div *ngIf="!availableStock" class="flex items-center bg-white px-6 py-4 mt-6">
            <span class="font-semibold text-gray-400 mb-4">{{ 'my_displays.prefered_arrival_date' | translate }}</span>
          </div>
          <div *ngIf="!availableStock" class="flex flex-col bg-white px-6 py-4">
            <app-date-filter
              [hasError]="preferedArrivalDateError"
              [initialValue]="applicationForm.preferedArrivalDateDate"
              [config]="{ label: 'my_displays.prefered_arrival_date_label' | translate, placeholder: 'my_displays.prefered_arrival_date_placeholder' | translate, max: null, format: getFormatDate() }"
              [isLoading]="false"
              (dateChanged)="onPreferedArrivalDateChanged($event)"
              (cleared)="onDateCleared()"
            ></app-date-filter>
             <div *ngIf="preferedArrivalDateError" style="color:#dc2626; font-size:12px; margin-top:6px;">
              {{ 'my_displays.invalid_date_error' | translate }}
            </div>
          </div>
        </div>
        <div class="flex flex-col md:flex-row items-center gap-5 bg-white px-6 py-4">
        </div>
        <div class="flex flex-col md:flex-row items-center gap-5 bg-white px-6 py-4">
        </div>
      </div>
      <!-- <div *ngIf="this.sinkForm.model !== '' || this.showerForm.model !== ''" class="bg-white px-6 py-4 mt-6">
        <span class="text-lg font-semibold text-gray-400 mb-4">
          {{ ('my_displays.select_application_details' | translate) }}
        </span>
        <div class="mb-6 header"></div>
        <div class="flex items-center bg-white px-6 py-4 mt-6">
          <span>AQUI VAN LOS FILTROS PARTE 2</span>
          <app-combobox
            fieldLabel="{{ 'my_displays.brand_label' | translate }}"
            placeholder="{{ 'my_displays.brand_placeholder' | translate }}"
            [selectedValue]="applicationForm.brand"
            [options]="getBrands()"
            (change)="selectBrand($event)">
          </app-combobox>
          <app-combobox
            fieldLabel="{{ 'my_displays.color_label' | translate }}"
            placeholder="{{ 'my_displays.color_placeholder' | translate }}"
            [disabled]="applicationForm.finish === ''"
            [selectedValue]="applicationForm.color"
            [options]="getColors()"
            (change)="selectColor($event)">
          </app-combobox>
          <app-combobox
            fieldLabel="{{ 'my_displays.finish_label' | translate }}"
            placeholder="{{ 'my_displays.finish_placeholder' | translate }}"
            [disabled]="applicationForm.format === ''"
            [selectedValue]="applicationForm.thickness"
            [options]="getThicknesses()"
            (change)="selectThickness($event)">
          </app-combobox>
        </div>
      </div> -->

      <div *ngIf="applicationColorSelected" class="bg-white px-6 py-4 mt-6">
        <span class="text-lg font-semibold text-gray-400 mb-4">
          {{ ('my_displays.select_application_color' | translate) }}
        </span>
        <div class="mb-6 header"></div>
        <div class="flex items-center bg-white px-6 py-4 mt-6">
          <div class="imageMini" [ngStyle]="{'background-image': 'url(' + applicationForm.thumbImage + ')'}"></div>
          <div class="color-name">{{ applicationForm.name }}</div>
          <a class="modify-application" (click)="changeColor()">{{ 'my_displays.modifycolor' | translate }}</a>
        </div>
      </div>

      <div *ngIf="applicationColorSelected"  class="bg-white px-6 py-4 mt-6">
        <span class="text-lg font-semibold text-gray-400 mb-4">
          {{ ('my_displays.select_application_details' | translate) }}
        </span>
        <div class="mb-6 header"></div>
        <div *ngIf="this.applicationForm.application !== 'flooring'" class="bg-white px-6 py-4 mt-6">
            <div class="relative flex flex-col gap-2 items-start h-full w-1/2">
                <div class="typography-body-s-regular">{{ (this.userInfo.market === 'USA' ? 'my_displays.size_label_sqft' : 'my_displays.size_label_m2') | translate }}*</div>
                <input
                    #sizeInputNative
                    type="text"
                    inputmode="decimal"
                    class="min-h-[40px] box-border px-4 py-2 border border-border-secondary typography-body-m-regular appearance-none w-full"
                    [placeholder]="'my_displays.size_placeholder' | translate"
                    [value]="sizeDisplayValue || applicationForm.size"
                    (input)="onSizeInput($event)"
                    (blur)="onSizeBlur($event)"
                />
            </div>
        </div>
        <div class="grid grid-cols-[repeat(3,1fr)] gap-5 px-6 py-4 mt-6">
            <div class="col-span-3 md:col-span-1">
                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.finish_label' | translate }}*</p>
                <app-select
                    [disabled]="false"
                    [placeholder]="'my_displays.finish_placeholder' | translate"
                    [options]="finishOptions"
                    [selectedValue]="selectedFinishOption"
                    (selectedValueChanged)="selectFinish($event)">
                </app-select>
            </div>
            <div class="col-span-3 md:col-span-1">
                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.format_label' | translate }}*</p>
                <app-select
                    [disabled]="!applicationForm.finish"
                    [placeholder]="'my_displays.format_placeholder' | translate"
                    [options]="formatOptions"
                    [selectedValue]="selectedFormatOption"
                    (selectedValueChanged)="selectFormat($event)">
                </app-select>
            </div>
            <div class="col-span-3 md:col-span-1">
                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.thickness_label' | translate }}*</p>
                <app-select
                    [disabled]="!applicationForm.format"
                    [placeholder]="'my_displays.thickness_placeholder' | translate"
                    [options]="thicknessOptions"
                    [selectedValue]="selectedThicknessOption"
                    (selectedValueChanged)="selectThickness($event)">
                </app-select>
            </div>
        </div>
        <div *ngIf="addonOptions.length > 0" class="grid grid-cols-[repeat(3,1fr)] gap-5 px-6 py-4 mt-6">
          <div class="col-span-3 md:col-span-1">
            <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.addon_label' | translate }}</p>
            <app-select
              [disabled]="applicationForm.thickness === ''"
              [placeholder]="'my_displays.addon_placeholder' | translate"
              [options]="addonOptions"
              [selectedValue]="selectedAddonOption"
              (selectedValueChanged)="selectAddon($event)">
            </app-select>
          </div>
          <div *ngIf="this.textures.length > 0" class="col-span-3 md:col-span-1">
            <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_displays.texture_label' | translate }}</p>
            <app-select
              [disabled]="applicationForm.addon === ''"
              [placeholder]="'my_displays.texture_label' | translate"
              [options]="textureOptions"
              [selectedValue]="selectedTextureOption"
              (selectedValueChanged)="selectTexture($event)">
            </app-select>
          </div>
        </div>
        <div *ngIf="$any(userInfo.accountType) === 'FABRICATOR' || $any(userInfo.accountType) === 'DISTRIBUTOR'">
          <div class="flex items-center bg-white px-6 py-4 mt-6">
            <app-input
              class=""
              type="number"
              min="1"
              label="{{ 'my_displays.number_required_slabs' | translate }}"
              placeholder="2"
              [value]="applicationForm.requiredSlabs"
              (change)="onRequiredSlabsChange($event)"
            ></app-input>
            <alert *ngIf="!this.slabsSizeValid()" [type]="'warning'" class="flex items-center bg-white px-6 py-4 mt-6">
              {{ 'my_displays.required_slabs_error' | translate }}
            </alert>
          </div>
          <div class="flex items-center bg-white px-6 py-4 mt-6">
            <span class="font-semibold text-gray-400 mb-4">{{ 'my_displays.stock_available' | translate }}</span>
          </div>
          <div class="flex items-center bg-white px-6 py-4">
            <app-radio
                class="mr-6"
                label="{{ 'my_displays.stock_yes' | translate }}"
                [checked]="availableStock === true"
                (onClick)="setAvailableStock(true)"></app-radio>
              <app-radio
                label="{{ 'my_displays.stock_no' | translate }}"
                [checked]="availableStock === false"
                (onClick)="setAvailableStock(false)"></app-radio>
          </div>
          <div *ngIf="!availableStock" class="flex items-center bg-white px-6 py-4 mt-6">
            <span class="font-semibold text-gray-400 mb-4">{{ 'my_displays.prefered_arrival_date' | translate }}</span>
          </div>
          <div *ngIf="!availableStock" class="flex flex-col bg-white px-6 py-4">
            <app-date-filter
              [hasError]="preferedArrivalDateError"
              [initialValue]="applicationForm.preferedArrivalDateDate"
              [config]="{ label: 'my_displays.prefered_arrival_date_label' | translate, placeholder: 'my_displays.prefered_arrival_date_placeholder' | translate, max: null, format: getFormatDate() }"
              [isLoading]="false"
              (dateChanged)="onPreferedArrivalDateChanged($event)"
              (cleared)="onDateCleared()"
            ></app-date-filter>
             <div *ngIf="preferedArrivalDateError" style="color:#dc2626; font-size:12px; margin-top:6px;">
              {{ 'my_displays.invalid_date_error' | translate }}
            </div>
          </div>
        </div>
        <div class="flex items-center bg-white px-6 py-4">
          <span class="mb-4">{{ 'my_displays.mandatory_fields' | translate }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="addedApplications.length > 0 && addingNew === false" class="bg-white px-6 py-4">
      <span class="text-lg font-semibold text-gray-400 mb-4">
        {{ 'my_displays.application_summary_title' | translate }}
      </span>
      <div class="mb-6 header"></div>
      <div class="inputs grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 min-width-180">
        <div *ngFor="let app of addedApplications; let i = index" class="border-gray-300 p-4 flex flex-col" style="background-color: #f3f5fc;">
          <div class="text-sm text-center px-6">{{ 'my_displays.aplicacion1' | translate }}:</div>
          <div class="font-medium mb-2 text-center px-6 py-4">{{ ('my_displays.application_' + app.application) | translate }}</div>
          <img *ngIf="app.application === 'bath_showertray' || app.application === 'bath_sink'" [src]="'assets/images/models/' + (app.application === 'bath_showertray' ? 'showertray_' : 'sink_') + app.model + '.png'" class="h-32 object-cover mb-2 px-4 " loading="lazy" />
          <img *ngIf="app.application !== 'bath_showertray' && app.application !== 'bath_sink'"[src]="app.thumbImage" class="h-32 object-cover mb-2 px-4 " loading="lazy" />
          <div class="text-lg text-center font-bold px-6 py-6">{{ app.name }}</div>
          <div class="text-sm font-medium text-center">
            <img
              [src]="app.brand != null ? 'assets/icons/brands/' + app.brand.toLowerCase() + '-black.svg' : 'assets/icons/brands/default-black.svg'"
              [alt]="app.brand"
              class="brand-logo"
              loading="lazy"
            />
          </div>
          <div *ngIf="app.application !== 'bath_showertray' && app.application !== 'bath_sink' && app.application !== 'sink' && app.application !== 'flooring' && app.application !== 'bath_flooring'" class="text-sm text-center py-6">{{ (this.userInfo.market === 'USA' ? 'my_displays.size_label_sqft' : 'my_displays.size_label_m2') | translate }}: {{ app.size }}</div>
          <div class="flex justify-between text-sm text-blue-600 mt-4 pt-2 border-t border-gray-300">
            <app-button [ghost]="true" (onClick)="deleteApplication(i)">
              <span class="flex items-center">
                <span>{{ 'my_displays.delete' | translate }}</span>
                <img class="ml-2" [src]="'assets/icons/close.svg'" alt="Delete">
              </span>
            </app-button>
            <app-button [ghost]="true" (onClick)="editApplication(i)">
              <span class="flex items-center">
                <span>{{ 'my_displays.edit' | translate }}</span>
                <img class="px-5 py-2.5" [src]="'assets/icons/edit.svg'" alt="Edit">
              </span>
            </app-button>
          </div>
        </div>
        <ng-container *ngIf="!addingNew">
          <div
            class="flex flex-col items-center justify-center border-2 border-solid p-4 cursor-pointer hover:bg-blue-50 transition-colors"
            style="background-color: #f3f5fc; border-color: #365bca;"
            (click)="addNewApplication()">
            <div class="flex flex-col items-center">
              <img src="assets/icons/add.svg" alt="Upload" class="h-[50px]" />
              <div class="text-center">
                <span class="typography-title-m block">
                  {{ 'my_displays.add_application' | translate }}
                </span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div *ngIf="step === 3">
    <div class="bg-white px-6 py-8 mt-6">
      <span class="text-lg font-semibold text-gray-400 mb-4">
        {{ ('my_displays.attach_sketches' | translate) }}
      </span>
      <div class="mb-6 header"></div>

      <div class="inputs bg-blue-50 border border-blue-200 p-4 mt-6 text-sm text-gray-700 flex items-center px-6 mt-6 mb-6" style="background-color: rgb(255, 246, 212); border: none">
        <span class="inline-flex items-center mr-3">
          <img src="assets/icons/warning-icon.svg" alt="Upload" class="h-[20px]" />
          <span class="w-4 h-4 bg-blue-400 rounded-full flex items-center justify-center mr-2 text-white text-xs"></span>
          {{ 'my_displays.upload_warning' | translate }}
        </span>
      </div>
      <!-- Drag and Drop Upload Area -->
      <div class="inputs text-md font-bold mt-6 mb-4">{{ 'my_displays.upload_files' | translate }}</div>
      <div
        class="inputs relative flex cursor-pointer flex-col items-center justify-center border-2 border-dotted border-gray-200 p-6"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()"
        (drop)="onDrop($event)"
        [class.bg-blue-50]="isDragging">
        <input
          type="file"
          #fileInput
          class="absolute inset-0 h-full w-full cursor-pointer opacity-0"
          accept=".png,.jpg,.jpeg,.pdf"
          multiple
          (change)="onFileSelected($event)" />
        <img src="assets/icons/upload.svg" alt="Upload" class="h-[20px]" />
        <div class="mt-2 text-sm font-medium text-blue-600 mt-6"> {{ 'my_displays.upload_files' | translate }} </div>
        <div class="mt-1 text-xs text-gray-500 text-center mt-6"> {{ 'my_displays.supported_size_formats' | translate }}</div>
      </div>
      <!-- Error Message -->
      <div *ngIf="uploadError" class="text-red-600 text-sm mt-4 text-center">
        {{ uploadError | translate }}
      </div>
      <!-- Uploaded Sketches List -->
      <div *ngIf="uploadedSketches.length > 0" class="mb-6">
        <div *ngFor="let sketch of uploadedSketches; let i = index" class="p-4 flex flex-col">
          <div class="font-medium mb-2 text-center">{{ sketch.name }}</div>
          <div class="text-sm text-center text-gray-600">{{ (sketch.size / 1024 / 1024).toFixed(2) }} MB</div>
          <div class="text-sm text-center text-gray-600">{{ sketch.type.split('/')[1].toUpperCase() }}</div>
          <div class="flex justify-center text-sm text-blue-600 mt-4 pt-2 border-gray-200">
            <!-- <button class="hover:underline pr-6" (click)="deleteSketch(i)">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
              </svg>
            </button>
            <button
              type="button"
              (click)="downloadSketch(sketch)"
              class="text-blue-600 hover:text-blue-400 transition"
              title="Descargar imagen">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
              </svg>
            </button> -->
            <a class="hover:underline pr-6" (click)="deleteSketch(i)">{{'global.delete' | translate}}</a>
            <a class="hover:underline pr-6" (click)="downloadSketch(sketch)">{{'home.download' | translate}}</a>
            <a *ngIf="isImage(sketch.type)" class="hover:underline" (click)="previewSketch(sketch)">{{'home.preview' | translate}}</a>
          </div>
        </div>
      </div>
      <!-- Terms and Conditions -->
      <div class="mt-4">
        <label class="inputs flex items-center text-sm">
          <input type="checkbox" [(ngModel)]="acceptTerms" class="mr-2" />
          <a [href]="legalNoticeLink" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">
            {{ 'my_sales.accept_terms_label' | translate }}
          </a>
        </label>
      </div>
    </div>
  </div>

  <app-confirm-modal
    [isOpen]="isErrorModalVisible"
    [title]="errorModalTitle"
    [message]='errorModalMessage'
    [confirmText]="'common.buttons.close' | translate"
    [cancelText]="''"
    [buttonsInRow]="true"
    (onConfirm)="closeErrorModal()"
    (onClose)="closeErrorModal()"
  />

  <!-- Navigation Buttons (Siempre visible) -->
  <div class="sticky-nav-buttons bg-white mt-6 px-4 sm:px-6 py-4 flex flex-col md:flex-row md:justify-between md:items-center gap-3">
    <div >
      <app-button size="M" *ngIf="(addingNew && editingIndex === null && addedApplications.length > 0) || step > 1"
                  (click)="goBack()"
                  [primary]="false"
                  class="w-full">
        {{ 'my_displays.previous_step_button' | translate }}
      </app-button>
    </div>

    <div class="flex flex-col md:flex-row items-center gap-3">
      <div hidden *ngIf="((step === 1 || step === 2) && !addingNew && addedApplications.length > 0) || (step === 3 && uploadedSketches.length > 0)" class="w-full" >
        <app-button size="L" (click)="saveDraft()" [primary]="false" class="w-full one-line">
          {{ 'my_displays.save_draft_button' | translate }}
        </app-button>
      </div>

      <div class="w-full">
        <app-button size="M"
          class="w-full"
          [primary]="true"
          (click)="onContinue()"
          [disabled]="!canContinue()">
          {{ (addingNew ? 'my_displays.save_application_button' : (step === progressSteps.length ? 'my_displays.save_application_button' : 'my_displays.continue_button')) | translate }}
        </app-button>
      </div>
    </div>
  </div>
</div>
